import React from 'react'
import { styled } from '@mui/system';
import { Typography, Box, Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useNavigate } from "react-router-dom";
import EmailAvatar from '../HomePage/EmailAvatar';

const ContentHalf = styled('div')({
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflowY: 'auto',
    width: '80vw'
});
const GenerateButton = styled('button')({
    backgroundColor: '#2560CD',
    padding: '10px 30px',
    color: 'white',
    cursor: 'pointer',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    borderRadius: '10px',
    fontSize: '16px',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});

const DetailsDashboard = ({ name, data }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [selectedItemYo, setSelectedItemYo] = React.useState(null);
    const navigate = useNavigate();
    const handleDialogOpen = (yo) => {
        setSelectedItemYo(yo);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setSelectedItemYo(null);
        setDialogOpen(false);
    };

    return (
        <ContentHalf>
            <div style={{ display: "flex", alignItems: 'center', justifyContent: 'flex-end', width: '90%', padding: '10px' }}>
                <EmailAvatar />
            </div>
            <Typography style={{ fontFamily: 'Poppins, sans-serif', fontSize: '24px', fontWeight: 600 }}>Test History</Typography>
            {data.map((item, index) => (
                <div key={index} style={{ padding: '15px' }}>
                    <Box sx={{
                        display:
                            'flex', flexDirection: 'row',
                        justifyContent: 'space-between',
                        padding: '15px',
                        alignItems: 'center',
                        borderRadius: '12px',
                        background: '#9CE6F2',
                    }}>
                        <div style={{ padding: '15px' }}>
                            <Typography style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', fontWeight: 600 }}>Test Taken:</Typography>
                        </div>
                        <div style={{ padding: '15px' }}>
                            <Typography style={{ fontFamily: 'Poppins, sans-serif', fontSize: '16px', fontWeight: 600 }}>{item.timestamp}</Typography>
                        </div>
                        <GenerateButton
                            onClick={() => handleDialogOpen(item.yo)}
                        >
                            View Result
                        </GenerateButton>
                    </Box>
                </div >
            ))}
            <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth
                maxWidth="lg">
                <DialogTitle variant='h4' style={{ fontFamily: 'Poppins, sans-serif' }}><b>Your Result</b></DialogTitle>
                <DialogContent>
                    {selectedItemYo ? (
                        <TableContainer component={Paper} style={{ borderRadius: "12px", marginTop: '20px', fontFamily: 'Poppins, sans-serif' }}>
                            <Table>
                                <TableHead style={{ background: '#2560CD' }}>
                                    <TableRow>
                                        <TableCell style={{
                                            color: 'white',
                                            fontFamily: 'Poppins, sans-serif',
                                            fontWeight: 500,
                                            fontSize: '15px',
                                            border: '1px solid white'
                                        }}>Skill</TableCell>
                                        <TableCell style={{
                                            color: 'white',
                                            fontFamily: 'Poppins, sans-serif',
                                            fontWeight: 500,
                                            fontSize: '15px',
                                            border: '1px solid white'
                                        }}>Type</TableCell>
                                        <TableCell style={{
                                            color: 'white',
                                            fontFamily: 'Poppins, sans-serif',
                                            fontWeight: 500,
                                            fontSize: '15px',
                                            border: '1px solid white'
                                        }}>Rank</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedItemYo.map((item, index) => (
                                        <TableRow key={index} style={{ fontFamily: 'Poppins, sans-serif', border: "1px solid black" }}>
                                            <TableCell style={{ border: '1px solid black' }}>{item.question}</TableCell>
                                            <TableCell style={{ border: '1px solid black' }}>{item.type}</TableCell>
                                            <TableCell style={{ border: '1px solid black' }}>{item.rank}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography>No result selected.</Typography>
                    )}
                </DialogContent>
            </Dialog>
            <GenerateButton onClick={() => { navigate("/userdetails"); }}>Take Assessment</GenerateButton>
        </ContentHalf >
    )
}

export default DetailsDashboard;